
import {catchError} from 'rxjs/operators';
import {Injectable, isDevMode} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {environment} from "@env/environment";
import {Reports} from "@services/reports";
import {flattenMyObj} from "@services/common";
import {BehaviorSubject} from "rxjs";
import {IFieldDefinition, IQueryStructure, ISearchObj} from "@models/search.interface";
import {isNullOrUndefined} from "util";
import {ActivatedRouteSnapshot, Resolve, Router} from "@angular/router";

declare var jmespath: any;

@Injectable()
export class SearchService {

  public SearchInProgress = new BehaviorSubject({});
  private searchInProgress: boolean = false;
  public searchResults = new BehaviorSubject({});
  private _searchResults: ISearchObj;
  private baseRow: any = {};

  constructor(private _http: HttpClient, private _Reports: Reports, private router: Router) {
    this.searchResults.subscribe({
      next:(newVals: ISearchObj) => {
        this._searchResults = newVals;
      }
    });

    this.SearchInProgress.subscribe(
      (status: boolean) => {
        this.searchInProgress = typeof status == "object" ? false : status;
      }
    );
  }

  private loggit(field: string, value: any, error?: any) {
    if (error) {
      console.error(error);
    }
    console.log(field + " Error:", value);
  }

  public buildQuery(values: any, mapValues: any,  forCount?: boolean): any {

    let _queryBase: any = {query:{bool:{filter:[]}}};

    /*Seriously, I had to stringify/parse to get unique objects from a template. */
    let _buildingsFilter = JSON.parse(JSON.stringify(this._Reports.activeRpt.queryStructure.buildingNested));
    let _stylesFilter = JSON.parse(JSON.stringify(this._Reports.activeRpt.queryStructure.stylesNested));
    let _usesFilter = JSON.parse(JSON.stringify(this._Reports.activeRpt.queryStructure.usesNested));
    let _salesFilter = JSON.parse(JSON.stringify(this._Reports.activeRpt.queryStructure.salesNested));
    let _landSegmentsFilter = JSON.parse(JSON.stringify(this._Reports.activeRpt.queryStructure.landSegmentsNested));

    try {
      /*Account Info*/
      try {
        if (values["accounts"] && values["accounts"].value != null && values["accounts"].value.trim() != "") {
          let accounts = values["accounts"].value.trim().replace(/[\W]+/g, ",").toLowerCase().split(",");
          _queryBase.query.bool.filter.push({"terms":{"account_number":accounts}});
        }
        if (mapValues)
          _queryBase.query.bool.filter.push(mapValues);
          
      } catch (e) {
        this.loggit("accounts", values["accounts"].value, e);
      }
      try {
        if ((values["spnMin"] && values["spnMax"]) && (values["spnMin"].value && values["spnMax"].value)) {
          let spn = {"range":{"state_parcel_number":{}}};
          let spnMin = values["spnMin"].value;
          let spnMax = values["spnMax"].value;

          if (spnMin) {
            spn.range.state_parcel_number["gte"] = spnMin.replace(/[^\d]+/g, "");
          }
          if (spnMax) {
            spn.range.state_parcel_number["lte"] = spnMax.replace(/[^\d]+/g, "");
          }
          if (spnMin || spnMax) {
            _queryBase.query.bool.filter.push(spn);
          }
        }
      } catch (e) {
        this.loggit("spnMin", values["spnMin"].value, e);
        this.loggit("spnMax", values["spnMax"].value, e);
      }
      try {
        if (values["accountType"] && values["accountType"].value != null && values["accountType"].value.length > 0) {
          let accountTypesString = "";
          accountTypesString = values["accountType"].value.map((val) => {
            return val.value;
          });
          _queryBase.query.bool.filter.push({"terms":{"account_type":accountTypesString}});
        }
      } catch (e) {
        this.loggit("account_type", values["account_type"].value, e);
      }
      try {
        if (values["appraisalType"] && values["appraisalType"].value != null && values["appraisalType"].value.length > 0) {
          let appraisalTypeString = "";
          appraisalTypeString = values["appraisalType"].value.map((val) => {
            return val.value;
          });
          _queryBase.query.bool.filter.push({"terms":{"appraisal_type":appraisalTypeString}});
        }
      } catch (e) {
        this.loggit("appraisal_type", values["appraisal_type"].value, e);
      }
      try {
        if (values["ownerName"] && values["ownerName"].value) {
          _queryBase.query.bool.filter.push({"query_string":{"default_field":"primary_owner.name", "query":"*" + values["ownerName"].value.trim() + "*"}});
        }
      } catch (e) {
        this.loggit("ownerName", values["ownerName"].value, e);
      }
      try {
        if ((values["propertyValueMin"] && values["propertyValueMin"].value) || (values["propertyValueMax"] && values["propertyValueMax"].value)) {
          let actVal = {"range":{"actual_value_sum":{}}};
          let aMin = values["propertyValueMin"].value;
          let aMax = values["propertyValueMax"].value;

          if (!isNullOrUndefined(aMin)) {
            actVal.range.actual_value_sum["gte"] = aMin.replace(/[^\d]+/g, "");
          }
          if (!isNullOrUndefined(aMax)) {
            actVal.range.actual_value_sum["lte"] = aMax.replace(/[^\d]+/g, "");
          }
          if (aMin || aMax) {
            _queryBase.query.bool.filter.push(actVal);
          }
        }
      } catch (e) {
        this.loggit("propertyValueMin", values["propertyValueMin"].value, e);
        this.loggit("propertyValueMax", values["propertyValueMax"].value, e);
      }

      try {
        if (values["neighborhood"] && values["neighborhood"].value !==null && values["neighborhood"].value.length > 0) {
          let neighborhoodString = "";
          neighborhoodString = values["neighborhood"].value.map((val) => {
            return val.name;
          });
          _queryBase.query.bool.filter.push({"terms":{"neighborhood_code":neighborhoodString}});
        }
      } catch (e) {
        this.loggit("neighborhood", values["neighborhood"].value, e);
      }

      try {
        let neighborhoodExtension = values["neighborhood_extension"].value !== null ? values["neighborhood_extension"].value : null;
        if (neighborhoodExtension) {
          let extensionString = "";
          extensionString= values["neighborhood_extension"].value.map((val) => {
            return val.value;
          });        
          _queryBase.query.bool.filter.push({"terms":{"neighborhood_extension":extensionString}});
        }
      } catch (e) {
        this.loggit("neighborhood_extension", values["neighborhood_extension"].value, e);
      }



      try {
        if (values["lea"] && values["lea"].value !==null && values["lea"].value.length > 0) {
          let leaString = "";
          leaString = values["lea"].value.map((val) => {
            return val.value;
          });
          _queryBase.query.bool.filter.push({"terms":{"lea":leaString}});
        }
      } catch (e) {
        this.loggit("lea", values["lea"].value, e);
      }

      /*Building Attributes*/
      try {
        //Building Attributes
        let sqft = {"range":{"buildings.above_grade_square_feet":{}}};

        //if (values["squareFootageMin"] && values["squareFootageMin"].value != null
        let sqMin = values["squareFootageMin"].value;
        let sqMax = values["squareFootageMax"].value;

        if (sqMin) {
          sqft.range["buildings.above_grade_square_feet"]["gte"] = sqMin.replace(/[^\d]+/g, "");
        }
        if (sqMax) {
          sqft.range["buildings.above_grade_square_feet"]["lte"] = sqMax.replace(/[^\d]+/g, "");
        }
        if (sqMin || sqMax) {
          _buildingsFilter.nested.query.bool.filter.push(sqft);
        }

      } catch (e) {
        this.loggit("squareFootageMin", values["squareFootageMin"].value, e);
        this.loggit("squareFootageMax", values["squareFootageMax"].value, e);
      }
      try {
        if (values["builtAs"].value && values["builtAs"].value.length > 0) {
          let stylesSubCriteria: any = {
            "terms":{
              "buildings.styles.style_code":[]
            }
          };
          stylesSubCriteria.terms["buildings.styles.style_code"] = values["builtAs"].value.map((val) => {
            return val.code;
          });

          _stylesFilter.nested.query.bool.filter.push(stylesSubCriteria);
        }
      } catch (e) {
        this.loggit("builtAs", values["builtAs"].value, e);
      }
      try {
        if (values["quality"] && values["quality"].value != null && values["quality"].value.length > 0) {
          let qualitiesSubCriteria: any = {
            "terms":{
              "buildings.build_quality":[]
            }
          };
          qualitiesSubCriteria.terms["buildings.build_quality"] = values["quality"].value;
          _buildingsFilter.nested.query.bool.filter.push(qualitiesSubCriteria);
        }
      } catch (e) {
        this.loggit("quality", values["quality"].value, e);
      }
      try {
        if (values["occupancyCode"] && values["occupancyCode"].value != null && values["occupancyCode"].value.length > 0) {

          let useSubCriteria: any = {"terms":{"buildings.uses.use_code":[]}};

          useSubCriteria.terms["buildings.uses.use_code"] = values["occupancyCode"].value.map((val) => {
            return val.code;
          });
          _usesFilter.nested.query.bool.filter.push(useSubCriteria);
        }
      } catch (e) {
        this.loggit("occupancyCode", values["occupancyCode"].value, e);
      }
      try {
        let yearBuilt = {range:{"buildings.styles.year_built":{}}};

        //if (values["squareFootageMin"] && values["squareFootageMin"].value != null
        let ybMin = values["yearBuiltMin"].value !== null ? values["yearBuiltMin"].value : null;
        let ybMax = values["yearBuiltMax"].value !== null ? values["yearBuiltMax"].value : null;

        if (ybMin) {
          yearBuilt.range["buildings.styles.year_built"]["gte"] = ybMin;
        }
        if (ybMax) {
          yearBuilt.range["buildings.styles.year_built"]["lte"] = ybMax;
        }
        if (ybMin || ybMax) {

          _stylesFilter.nested.query.bool.filter.push(yearBuilt);
        }
      } catch (e) {
        this.loggit("yearBuiltMin", values["yearBuiltMin"].value, e);
        this.loggit("yearBuiltMax", values["yearBuiltMax"].value, e);
      }
      try {
        let basementSF = {range:{"buildings.basement.square_feet":{}}};

        //if (values["squareFootageMin"] && values["squareFootageMin"].value != null
        let bsfMin = values["basementSQFTMin"].value;
        let bsfMax = values["basementSQFTMax"].value;

        if (bsfMin) {
          basementSF.range["buildings.basement.square_feet"]["gte"] = bsfMin.replace(/[^\d]+/g, "");
        }
        if (bsfMax) {
          basementSF.range["buildings.basement.square_feet"]["lte"] = bsfMax.replace(/[^\d]+/g, "");
        }
        if (bsfMin || bsfMax) {
          _buildingsFilter.nested.query.bool.filter.push(basementSF);
        }
      } catch (e) {
        this.loggit("basementSQFTMin", values["basementSQFTMin"].value, e);
        this.loggit("basementSQFTMax", values["basementSQFTMax"].value, e);
      }
      try {
        if (values["basementFinish"] && values["basementFinish"].value != null) {
          let basementFinish = {"term":{"buildings.basement.finished":values["basementFinish"].value}};
          _buildingsFilter.nested.query.bool.filter.push(basementFinish);
        }
      } catch (e) {
        this.loggit("basementFinish", values["basementFinish"].value, e);
      }
      try {
        if (values["basementWalkOut"] && values["basementWalkOut"].value != null) {
          let basementWalkout = {"term":{"buildings.basement.walkout":values["basementWalkOut"].value}};
          _buildingsFilter.nested.query.bool.filter.push(basementWalkout);
        }
      } catch (e) {
        this.loggit("basementWalkOut", values["basementWalkOut"].value, e);
      }

      /*Sales Info*/
      try {
        let isSalesReport: boolean = this._Reports.activeRpt.key == "SalesInformationReport";

        let salePrice = {range:{"sales.sale_price":{}}};
        let isASale = {term:{"sales.non_sale":false}};
        let spMin = values["salePriceMin"].value;
        let spMax = values["salePriceMax"].value;

        if (spMin) {
          salePrice.range["sales.sale_price"]["gte"] = spMin.replace(/[^\d]+/g, "");
        }
        if (spMax) {
          salePrice.range["sales.sale_price"]["lte"] = spMax.replace(/[^\d]+/g, "");
        }

        if ((spMin || spMax) || isSalesReport) {
          _salesFilter.nested.query.bool.filter.push(isASale);
        }
        if ((spMin || spMax)) {
          _salesFilter.nested.query.bool.filter.push(salePrice);
        }
      } catch (e) {
        this.loggit("salePriceMin", values["salePriceMin"].value, e);
        this.loggit("salePriceMax", values["salePriceMax"].value, e);
      }
      try {
        let saleDate = {"range":{"sales.sale_date":{}}};
        let sdMin = values["saleDateMin"].value !== null ? values["saleDateMin"].value : null;
        let sdMax = values["saleDateMax"].value !== null ? values["saleDateMax"].value : null;

        if (sdMin) {
          saleDate.range["sales.sale_date"]["gte"] = new Date(sdMin).toISOString();
        }
        if (sdMax) {
          saleDate.range["sales.sale_date"]["lte"] = new Date(sdMax).toISOString();
        }
        if (sdMin || sdMax) {
          _salesFilter.nested.query.bool.filter.push(saleDate);
        }

      } catch (e) {
        this.loggit("saleDateMin", values["saleDateMin"].value, e);
        this.loggit("saleDateMax", values["saleDateMax"].value, e);
      }
      try {
        let recNo = {"term":{"sales.recording_number":""}};
        let srNo = values["saleRecordingNumber"].value !== null ? values["saleRecordingNumber"].value : null;
        if (srNo) {
          recNo.term["sales.recording_number"] = srNo;
          _salesFilter.nested.query.bool.filter.push(recNo);
        }

      } catch (e) {
        this.loggit("saleRecordingNumber", values["saleRecordingNumber"].value, e);
      }

      try {
        let saleGrantor = {"match_phrase":{"sales.grantor":""}};
        let grantorValue = values["grantor"].value != null ? values["grantor"].value : null;
        if (grantorValue) {
          saleGrantor.match_phrase["sales.grantor"] = grantorValue;
          _salesFilter.nested.query.bool.filter.push(saleGrantor);
        }
      } catch (e) {
        this.loggit("grantor", values["grantor"].value, e);
      }

      try {
        let saleGrantee = {"match_phrase":{"sales.grantee":""}};
        let granteeValue = values["grantee"].value != null ? values["grantee"].value : null;
        if (granteeValue) {
          saleGrantee.match_phrase["sales.grantee"] = granteeValue;
          _salesFilter.nested.query.bool.filter.push(saleGrantee);
         
        }
      } catch (e) {
        this.loggit("grantee", values["grantee"].value, e);
      }

      try {
        if (values["deedType"].value && values["deedType"].value.length > 0) {
          let deedTypeCriteria: any = {
            "terms":{
              "sales.deed_type":[]
            }
          };
          deedTypeCriteria.terms["sales.deed_type"] = values["deedType"].value.map((val) => {
            return val.value;
          });
          _salesFilter.nested.query.bool.filter.push(deedTypeCriteria);
        }
      } catch (e) {
        this.loggit("deedType", values["deedType"].value, e);
      }

      try { 
        let improvedValue = values["vacant_improved"].value !== null ? values["vacant_improved"].value : null;
        if (improvedValue !== null) {
            let improvedTerm = {"term":{"sales.improved":""}};
            improvedTerm.term["sales.improved"] = improvedValue;
            _salesFilter.nested.query.bool.filter.push(improvedTerm);
        }

      } catch (e) {
        this.loggit("vacant_improved", values["vacant_improved"].value, e);        
      }

      try {
        let qualifiedSaleValue = values["qualified_sale"].value !== null ? values["qualified_sale"].value : null;
        if (qualifiedSaleValue !== null) {
            let qualifiedSaleTerm = {"term":{"sales.qualified_sale":""}}; 
            qualifiedSaleTerm.term["sales.qualified_sale"] = qualifiedSaleValue;
            _salesFilter.nested.query.bool.filter.push(qualifiedSaleTerm);
        }

      } catch (e) {
        this.loggit("qualified_sale", values["qualified_sale"].value, e);        
      }

      try { 
        let multiParcelValue = values["multi_parcel"].value !== null ? values["multi_parcel"].value : null;
        if (multiParcelValue !== null) {
            let multiParcelTerm = {"term":{"sales.multi_parcel":multiParcelValue}};
            _salesFilter.nested.query.bool.filter.push(multiParcelTerm);
        }

      } catch (e) {
        this.loggit("multi_parcel", values["multi_parcel"].value, e);        
      }


      /*Subdivision Attributes*/
      try {
        let subSrch = {"terms":{"subdivision.number":[]}};

        let subDiv = values["subDivision"].value !== null ? values["subDivision"].value : null;
        if (subDiv) {
          subSrch.terms["subdivision.number"] = subDiv.map(sub => {return sub.number;});
          _queryBase.query.bool.filter.push(subSrch);
        }

      } catch (e) {
        this.loggit("subDivision", values["subDivision"].value, e);
      }
      try {
        let subFilings = {"terms":{"subdivision.filing.recording_number":[]}};

        let subDiv = values["sub_filings"].value !== null ? values["sub_filings"].value : null;
        if (subDiv) {
          subFilings.terms["subdivision.filing.recording_number"] = subDiv;
          _queryBase.query.bool.filter.push(subFilings);
        }
      } catch (e) {
        this.loggit("sub_filings", values["sub_filings"].value, e);
      }
      try {
        if (values["block"] && values["block"].value) {
          let blocksString = {"term":{"subdivision.block":{"value":""}}};
          let block = values["block"].value !== null ? values["block"].value : null;
          if (block) {
            blocksString.term["subdivision.block"].value = block;
            _queryBase.query.bool.filter.push(blocksString);
          }
        }
      } catch (e) {
        this.loggit("block", values["block"].value, e);
      }
      try {
        if (values["lot"] && values["lot"].value) {
          let lotVal = {"term":{"subdivision.lot":{"value":values["lot"].value}}};
          _queryBase.query.bool.filter.push(lotVal);
        }
      } catch (e) {
        this.loggit("lot", values["lot"].value, e);
      }
      try {
        if (values["tract"] && values["tract"].value) {
          let tractVal = {"term":{"subdivision.tract":{"value":values["tract"].value}}};
          _queryBase.query.bool.filter.push(tractVal);
        }
      } catch (e) {
        this.loggit("tract", values["tract"].value, e);
      }
      try {
        if (values["recording_number"] && values["recording_number"].value && values["recording_number"].value.trim() != "") {
          _queryBase.query.bool.filter.push({"term":{"recording_number":values["recording_number"].value.trim()}});
        }
      } catch (e) {
        this.loggit("recording_number", values["recording_number"].value, e);
      }


      /*Tax Information*/
      try {
        if (values["taxDistrict"] && values["taxDistrict"].value != null && values["taxDistrict"].value.length > 0) {
          let taxDistrictString = "";
          taxDistrictString = values["taxDistrict"].value.map((val) => {
            return val.value;
          });
          _queryBase.query.bool.filter.push({"terms":{"tax_district_number":taxDistrictString}});
        }

      } catch (e) {
        this.loggit("taxDistrict", values["taxDistrict"].value, e);
      }
      try {
        if (values["taxAuthority"] && values["taxAuthority"].value != null && values["taxAuthority"].value.length > 0) {
          let taxAuthorityString = "";
          taxAuthorityString = values["taxAuthority"].value.map((val) => {
            return val.value;
          });
          _queryBase.query.bool.filter.push({"terms":{"tax_authority_ids":taxAuthorityString}});
        }
      } catch (e) {
        this.loggit("taxDistrict", values["taxDistrict"].value, e);
      }

      /* Address */
      try {
        if ((values["streetNumberMin"] && values["streetNumberMin"].value != null && values["streetNumberMin"].value > 0) ||
          (values["streetNumberMax"] && values["streetNumberMax"].value != null && values["streetNumberMax"].value > 0)) {
          _queryBase.query.bool.filter.push({
            "range":{
              "primary_address.address_number":{
                "gte":values["streetNumberMin"].value,
                "lte":values["streetNumberMax"].value
              }
            }
          });
        }
      } catch (e) {
        this.loggit("streetNumberMin", values["streetNumberMin"].value, e);
        this.loggit("streetNumberMax", values["streetNumberMax"].value, e);
      }
      try {
        let subSrch = {"term":{"primary_address.street_name":{"value":""}}};

        let street = values["streetName"].value !== null ? values["streetName"].value : null;
        if (street) {
          subSrch.term["primary_address.street_name"].value = street.label;
          _queryBase.query.bool.filter.push(subSrch);
        }
      } catch (e) {
        this.loggit("streetName", values["streetName"].value, e);

      }
      try {
        if (values["city"] && values["city"].value != null && values["city"].value.length > 0) {
          let citysString = "";
          citysString = values["city"].value.map((val) => {
            return val.value;
          });
          _queryBase.query.bool.filter.push({"terms":{"primary_address.city":citysString}});
        }
      } catch (e) {
        this.loggit("city", values["city"].value, e);
      }
      try {
        if (values["zipCode"] && values["zipCode"].value && values["zipCode"].value.length > 0) {

          _queryBase.query.bool.filter.push({"terms":{"primary_address.zip_code":values["zipCode"].value}});
        }
      } catch (e) {
        this.loggit("zipCode", values["zipCode"].value, e);
      }

      /*Land Use*/
      try {
        //Land Attributes
        if (values["landUse"] && values["landUse"].value) {
          let landUse = {"term":{"land_segments.class_code":{"value":""}}};

          landUse.term["land_segments.class_code"].value = values["landUse"].value.value;
          _landSegmentsFilter.nested.query.bool.filter.push(landUse);
        }
      } catch (e) {
        this.loggit("landUse", values["landUse"].value, e);
      }
      /*Land Attributes*/
      try {
        if (values["landAttribute"] && values["landAttribute"].value) {
          let lattributes = {"terms":{"land_attributes":[]}};
          let atts = values["landAttribute"].value.map((att) => {
            return att.code + " - " + att.description;
          });
          if (atts) {
            lattributes.terms.land_attributes = atts;
            _queryBase.query.bool.filter.push(lattributes);
          }
        }
      } catch (e) {
        this.loggit("landAttribute", values["landAttribute"].value, e);
      }
      try {
        if ((values["acresMin"] && values["acresMin"].value) || (values["acresMax"] && values["acresMax"].value)) {
          let actVal = {range:{net_acres_sum:{}}};
          let aMin = values["acresMin"].value;
          let aMax = values["acresMax"].value;

          if (aMin) {
            actVal.range.net_acres_sum["gte"] = aMin;
          }
          if (aMax) {
            actVal.range.net_acres_sum["lte"] = aMax;
          }
          if (aMin || aMax) {
            _queryBase.query.bool.filter.push(actVal);
          }
        }
      } catch (e) {
        this.loggit("acresMin", values["acresMin"].value, e);
        this.loggit("acresMax", values["acresMax"].value, e);
      }
      try {
        if (values["township"] && values["township"].value) {
          _queryBase.query.bool.filter.push({"term":{"land_survey.township":values["township"].value}});
        }
      } catch (e) {
        this.loggit("township", values["township"].value, e);
      }
      try {
        if (values["range"] && values["range"].value) {
          _queryBase.query.bool.filter.push({"term":{"land_survey.range":values["range"].value}});
        }
      } catch (e) {
        this.loggit("range", values["range"].value, e);
      }
      try {
        if (values["section"] && values["section"].value) {
          _queryBase.query.bool.filter.push({"term":{"land_survey.section":values["section"].value}});
        }
      } catch (e) {
        this.loggit("section", values["section"].value, e);
      }

      let queryStructs: { searchQuery: any, countQuery: any } = {searchQuery:null, countQuery:null};

      queryStructs.searchQuery = JSON.parse(JSON.stringify(_queryBase));
      queryStructs.searchQuery["_source"] = JSON.parse(JSON.stringify(this._Reports.activeRpt.queryStructure.acctIncludes));
      queryStructs.countQuery = JSON.parse(JSON.stringify(_queryBase));

      if (this._Reports.activeRpt.queryStructure.usesInnerHits || _usesFilter.nested.query.bool.filter.length > 0) {
        _usesFilter.nested["inner_hits"] = JSON.parse(JSON.stringify(this._Reports.activeRpt.queryStructure.usesInnerHits));
        /*}
			 if (_usesFilter.nested.query.bool.filter.length > 0) {*/
        _buildingsFilter.nested.query.bool.filter.push(_usesFilter);
      }

      if (this._Reports.activeRpt.queryStructure.stylesInnerHits || _stylesFilter.nested.query.bool.filter.length > 0) {
        _stylesFilter.nested["inner_hits"] = JSON.parse(JSON.stringify(this._Reports.activeRpt.queryStructure.stylesInnerHits));
        /*}
				if (_stylesFilter.nested.query.bool.filter.length > 0) {*/
        _buildingsFilter.nested.query.bool.filter.push(_stylesFilter);
      }

      if (this._Reports.activeRpt.queryStructure.buildingInnerHits || _buildingsFilter.nested.query.bool.filter.length > 0) {
        _buildingsFilter.nested["inner_hits"] = JSON.parse(JSON.stringify(this._Reports.activeRpt.queryStructure.buildingInnerHits));
        /*}
				if (_buildingsFilter.nested.query.bool.filter.length > 0) {*/
        queryStructs.countQuery.query.bool.filter.push(_buildingsFilter);
        queryStructs.searchQuery.query.bool.filter.push(_buildingsFilter);
      }

      if (this._Reports.activeRpt.queryStructure.salesInnerHits || _salesFilter.nested.query.bool.filter.length > 0) {
        _salesFilter.nested["inner_hits"] = JSON.parse(JSON.stringify(this._Reports.activeRpt.queryStructure.salesInnerHits));
        /*}
				if (_salesFilter.nested.query.bool.filter.length > 0) {*/
        queryStructs.countQuery.query.bool.filter.push(_salesFilter);
        queryStructs.searchQuery.query.bool.filter.push(_salesFilter);
      }

      if (this._Reports.activeRpt.queryStructure.landSegmentsInnerHits || _landSegmentsFilter.nested.query.bool.filter.length > 0) {
        _landSegmentsFilter.nested["inner_hits"] = JSON.parse(JSON.stringify(this._Reports.activeRpt.queryStructure.landSegmentsInnerHits));
      /*}
      if (_landSegmentsFilter.nested.query.bool.filter.length > 0) {*/
        queryStructs.countQuery.query.bool.filter.push(_landSegmentsFilter);
        queryStructs.searchQuery.query.bool.filter.push(_landSegmentsFilter);
      }

      queryStructs.searchQuery.sort = "_id";
      queryStructs.searchQuery.size = 10000;
      if (isDevMode()) {
        console.info("searchQuery: ", JSON.stringify(queryStructs.searchQuery));
        console.info("countQuery: ", JSON.stringify(queryStructs.countQuery));
      }
      return queryStructs;

    } catch (e) {

      toastr.error(e.message, "Query Construction Error");
      this.SearchInProgress.next(false);
      return null;

    }
  }

  public Search(account ?: string) {
    let q = JSON.parse(JSON.stringify(this._searchResults.searchQuery));
    if (account) {
      q["search_after"] = [account];
    }
    return this._http.post(environment.elasticReader.host + environment.elasticReader.search, q).pipe(
               catchError(
                 error => {
                   this.SearchInProgress.next(false);
                   this.router.navigate(["/404"], {queryParams:{error:JSON.stringify(error)}});
                   return [];
                 }
               ));
  }

  public LogSearchQuery() {
    console.log(JSON.stringify(this._searchResults.searchQuery));
  }

  public getCount(queryParams: any,  mapParams: any): Promise<any> {

    return new Promise(resolve => {
      let x: ISearchObj = {
        preFetch:{count:0, over10k:false, requests:0, remainder:0},
        displayColumns:jmespath.search(this._Reports.activeRpt, "sort_by(fields, &order)[?display==`true`]"),
        totalHits:0,
        rows:[],
        rowCount:0,
        hasResults:false,
        searchTime:0,
        accountMilestones:[],
        resultMessage:"",
        hardStop:50000,
        searchQuery:{},
        countQuery:{}
      };
      let queries: any = this.buildQuery(queryParams, mapParams);

      x.countQuery = queries.countQuery;
      x.searchQuery = queries.searchQuery;

      this.searchResults.next(x);

      let countQ = Object.assign({}, x.countQuery);

      this._http.post(
        environment.elasticReader.host + environment.elasticReader.count,
        countQ, {headers:environment.elasticReader.headers}).pipe(
          catchError(
            error => {
              this.SearchInProgress.next(false);
              this.router.navigate(["/404"], {queryParams:{error:JSON.stringify(error)}});
              return [];
            }
          ))
          .subscribe((res: any) => {
            x.preFetch = {
              /*count:res.count,*/
              count:res.count,
              over10k:res.count > 10000,
              requests:Math.ceil(res.count / 10000),
              remainder:res.count % 10000
            };

            // if (res.count > x.hardStop) {
              // x.preFetch.requests = Math.ceil(x.hardStop / 10000);
              // x.preFetch.remainder = x.hardStop % 10000;
            // }
            x.resultMessage = "Search Results: " + x.preFetch.count.toString() + " accounts";            
            // x.resultMessage = x.preFetch.count > 200000 ? "Search Results: " + x.hardStop.toString() + " of " + x.preFetch.count.toString() + " accounts" : "Search Results: " + x.preFetch.count.toString() + " accounts";
            this.searchResults.next(x);
            resolve(x);
          }, error1 => {
            toastr.error(error1, "getCount Error");
            this.SearchInProgress.next(false);
          });
    });
  }

  public flattenJSON(data: Array<any>, asCSV ?: boolean): Promise<any> {
    return new Promise(resolve => {
        if (data.length == 0) {
          resolve(data);
        }
        let prime = this._Reports.activeRpt.nestedPrime;
        let childPath = this._Reports.activeRpt.nestedChildren;
        let rowCollection: Array<any> = [];
        let computFields = this._Reports.activeRpt.fields.filter((_field) => {
          return _field.hasOwnProperty("compute");
        });

        // console.log(computFields);

        data.map((account: any) => {

          let accountSource = account._source;
          let rows = prime ? jmespath.search(account, prime) || [] : [];

          /*cleanup*/
          if (prime) {
            if (prime.indexOf("_source") > -1 && rows.length > 0) {
              let k = prime.replace("_source.", "");
              delete accountSource[k];
            } else {
              delete accountSource[prime];
            }
          }
          accountSource = flattenMyObj(accountSource);

          if (rows.length > 0) {
            rows.map((row) => {
              let rowSource:any;
              if (row._source) {
                rowSource = flattenMyObj(row._source);
              } else {
                rowSource = flattenMyObj(row);
              }
              computFields.map((cField: IFieldDefinition) => {
                if (jmespath.search(rowSource, cField.compute.requires)) {
                  rowSource[cField.fieldName] = eval(jmespath.search(rowSource, cField.compute.variables[0]) + cField.compute.operation + jmespath.search(rowSource, cField.compute.variables[1])) || 0;
                }
              });
              Object.assign(rowSource, accountSource);
              if (childPath) {
                let children = jmespath.search(row, childPath) || [];
                //delete rowSource[childPath];
                if (children.length > 0) {
                  /* ITERATE DATA THAT DUPLICATES DUPLICATE ROWS */
                  children.map((_child: any) => {
                    rowCollection.push(Object.assign(flattenMyObj(_child._source), rowSource));
                  });
                }
              } else {
                rowCollection.push(flattenMyObj(rowSource));
              }
            });
          } else {
            rowCollection.push(accountSource);
          }

        });
        resolve(rowCollection);
      }
    );
  }

  public resetResults() {
    this.searchResults.next({
      preFetch:{},
      displayColumns:[],
      totalHits:0,
      rows:[],
      rowCount:0,
      hasResults:false,
      searchTime:0
    });
  }
}
